<script>
import { MapAgentStationStatus, MapRefundStatus } from "@/common/util";
import basicLineChart from "@/components/visionStatistics/basicLineChart.vue";
import basicBarChart from "@/components/visionStatistics/basicBarChart.vue";

import sortBy from "lodash/sortBy";
import cloneDeep from "lodash/cloneDeep";
import forOwn from "lodash/forOwn";
import moment from "moment";
const mapTabName = {
  agent: "新增代理商",
  sales: "终端销量",
  stock: "代理商库存",
  courseBuy: "代理商进货",
  courseRefund: "代理商退货",
  station: "新增医疗机构",
  lively: "活跃医疗机构"
};
export default {
  components: {
    basicLineChart,
    basicBarChart
  },
  data() {
    const defaultDate = [
      moment()
        .subtract(1, "months")
        .format("YYYY-MM-DD"),
      moment().format("YYYY-MM-DD")
    ];
    const roles =
      localStorage.getItem("roles").indexOf("ROLE_SUPER_ADMIN") > -1
        ? "superAdmin"
        : "regionManager";
    return {
      roles,
      dateRange: defaultDate,
      dateRangeStock: defaultDate,
      chartArray: [],
      needRefresh1: true,
      needRefresh2: true,
      ProvinceList: [],
      provinceCity: undefined,
      achievementData: {
        remainingTreatmentCount: undefined,
        sales: undefined,
        targetCount: undefined
      },
      options: [
        {
          value: "YEAR",
          label: "年度"
        },
        {
          value: "QUARTER",
          label: "季度"
        },
        {
          value: "MONTH",
          label: "月度"
        }
      ],
      dateRangeValue: "MONTH",
      activeTab: "sales",
      totalSales: {
        StatisticsResult: undefined,
        chartTitle: undefined,
        chartYTitle: undefined,
        yType: undefined,
        seriesNameY: undefined
      },
      dateRangeTotalSales: undefined,
      AgentSalesAndStation: {
        StatisticsResult: undefined,
        chartTitle: undefined,
        chartYTitle: undefined,
        yType: undefined,
        seriesNameY: undefined
      },
      regionList: [],
      regionId: undefined,
      totalStock: undefined,
      dateRangeTotalStock: undefined,
      stationList: [],
      stationId: undefined,
      tempRegion: [],
      tempProvinceCity: []
    };
  },
  created() {
    this.loadProvice();
    this.loadData();
    this.loadStation();
    this.managerSales();
    this.loadStatistic();
  },
  methods: {
    async loadData() {
      const result = await this.$http.AdminRegionList();
      if (result) {
        this.tempRegion = cloneDeep(result);
        this.regionList = result.map(o => {
          return {
            label: o.region.regionName,
            value: o.region.id
          };
        });
      }
    },
    async loadProvice() {
      let ProvinceList = await this.$http.getProvinceList(this.roles);
      if (ProvinceList.length > 0) {
        const provinceChildren = ProvinceList.map(o => {
          return {
            label: o.name,
            keyName: o.id,
            value: o.id,
            children: o.sons.map(o => {
              return {
                label: o.name,
                value: o.id
              };
            }),
            id: o.id,
            name: o.name
          };
        });
        this.ProvinceList = cloneDeep(provinceChildren);
        this.tempProvinceCity = cloneDeep(provinceChildren);
      }
    },
    async loadStation() {
      const params = {};
      if (this.provinceCity && this.provinceCity[0]) {
        params.provinceId = this.provinceCity[0];
      }
      if (this.provinceCity && this.provinceCity[1]) {
        params.cityId = this.provinceCity[1];
      }
      let stationList = await this.$http.getStationListByCityId(params);
      if (stationList.length > 0) {
        const provinceChildren = stationList.map(o => {
          return {
            label: o.name,
            keyName: o.stationUUID,
            value: o.stationUUID
          };
        });
        this.stationList = provinceChildren;
      }
    },
    onSearch() {
      this.loadStatistic();
    },
    async loadStatistic() {
      const params = {};
      if (this.regionId) {
        params.regionId = this.regionId;
      }
      const chartType = this.activeTab;
      if (chartType === "courseBuy" || chartType === "courseRefund") {
        params.operateType = chartType === "courseBuy" ? "PAY" : "REFUND";
      }
      params.statisticType = this.dateRangeValue === "YEAR" ? "YEAR" : "MONTH";
      if (this.dateRangeValue !== "YEAR") {
        params.end = moment().format("YYYY-MM-DD");
        params.start = moment()
          .subtract(11, "month")
          .startOf("month")
          .format("YYYY-MM-DD");
      }

      if (this.provinceCity && this.provinceCity[0]) {
        params.provinceId = this.provinceCity[0];
      }
      if (this.provinceCity && this.provinceCity[1]) {
        params.cityId = this.provinceCity[1];
      }
      let result = [];
      if (this.stationId) {
        params.stationUUID = this.stationId;
        result = await this.$http.getStationSalesById(params);
      } else {
        result = await this.$http.managerRangeStatistic(params, chartType);
      }

      if (this.dateRangeValue === "YEAR") {
        let AgentSalesAndStation = {
          chartTitle: undefined,
          chartYTitle: "个数",
          yType: "AgentSalesAndStation",
          seriesNameY: mapTabName[chartType],
          StatisticsX: [],
          StatisticsY: [],
          legend: []
        };
        if (chartType === "sales") {
          AgentSalesAndStation.legend = ["实际销售", "销售目标"];
        }
        const tempX = [];
        const tempY1 = [];
        const tempY2 = [];
        result.forEach(item => {
          tempX.push(`${moment(item.time).get("year")}年`);
          tempY1.push(item.count);
          tempY2.push(item.targetCount);
        });
        AgentSalesAndStation.StatisticsX.push(tempX);
        AgentSalesAndStation.StatisticsY.push(tempY1);
        if (chartType === "client") {
          AgentSalesAndStation.StatisticsY.push(tempY2);
        }
        this.AgentSalesAndStation = AgentSalesAndStation;
      } else if (this.dateRangeValue === "QUARTER") {
        const AgentSalesAndStation = {
          chartTitle: undefined,
          chartYTitle: "个数",
          yType: "AgentSalesAndStation",
          seriesNameY: mapTabName[chartType],
          StatisticsX: [],
          StatisticsY: [],
          legend: []
        };
        const tempX = [];
        const tempY1 = [];
        const mapQuarter = {};
        result.forEach(item => {
          const tempQuarter = `${moment(item.time).year()}年第${moment(
            item.time
          ).quarter()}季度`;
          if (mapQuarter[tempQuarter]) {
            mapQuarter[tempQuarter] = mapQuarter[tempQuarter] + item.count;
          } else {
            mapQuarter[tempQuarter] = item.count;
          }
        });
        for (let item in mapQuarter) {
          tempX.push(item);
          tempY1.push(mapQuarter[item]);
        }
        AgentSalesAndStation.StatisticsX.push(tempX);
        AgentSalesAndStation.StatisticsY.push(tempY1);
        this.AgentSalesAndStation = AgentSalesAndStation;
      } else {
        const AgentSalesAndStation = {
          chartTitle: undefined,
          chartYTitle: "个数",
          yType: "AgentSalesAndStation",
          seriesNameY: mapTabName[chartType],
          StatisticsX: [],
          StatisticsY: [],
          legend: []
        };
        const tempX = [];
        const tempY1 = [];
        result.forEach(item => {
          tempX.push(`${moment(item.time).get("month") + 1}月`);
          tempY1.push(item.count);
        });
        AgentSalesAndStation.StatisticsX.push(tempX);
        AgentSalesAndStation.StatisticsY.push(tempY1);
        this.AgentSalesAndStation = AgentSalesAndStation;
      }

      this.needRefresh1 = false;
      this.$nextTick(() => {
        this.needRefresh1 = true;
      });
    },
    async managerSales() {
      const params = {
        start: this.dateRange[0],
        end: this.dateRange[1]
      };
      const result = await this.$http.managerSalesStatistic(params);
      const totalSales = {
        chartTitle: undefined,
        chartYTitle: "销量",
        yType: "totalSales",
        seriesNameY: "累计销量",
        StatisticsResult: []
      };
      let total = 0;
      result.forEach(item => {
        total = total + item.count;
        totalSales.StatisticsResult.push({
          createdAt: item.time,
          value: total
        });
      });
      this.dateRangeTotalSales = total;
      this.totalSales = totalSales;
      console.log("totalSales", totalSales);
      this.needRefresh2 = false;
      this.$nextTick(() => {
        this.needRefresh2 = true;
      });
    },
    onSwitchTab(tabName) {
      this.activeTab = tabName;
      this.loadStatistic();
    },
    onDateChange() {
      this.managerSales();
    },
    onDateTypeChange() {
      this.loadStatistic();
    },
    onProvinceChange(value) {
      console.log(value, this.provinceCity);
      this.loadStation();
    },
    onClerarData() {},
    onStationSelect() {
      if (this.stationId && this.activeTab !== "sales") {
        this.activeTab = "sales";
        // const AgentSalesAndStation = {
        //   chartTitle: undefined,
        //   chartYTitle: "个数",
        //   yType: "AgentSalesAndStation",
        //   seriesNameY: mapTabName["sales"],
        //   StatisticsX: [],
        //   StatisticsY: [],
        //   legend: []
        // };
        // const tempX = [];
        // const tempY1 = [];
        // AgentSalesAndStation.StatisticsX.push(tempX);
        // AgentSalesAndStation.StatisticsY.push(tempY1);
        // this.AgentSalesAndStation = AgentSalesAndStation;
        // this.needRefresh1 = false;
        // this.$nextTick(() => {
        //   this.needRefresh1 = true;
        // });
      }
    },
    onRangeSelect(value) {
      if (value) {
        const activeRegion = this.tempRegion.filter(
          o => o.region.id === value
        )[0];
        if (activeRegion && activeRegion.provinceNames.length > 0) {
          const temp = this.tempProvinceCity.filter(
            o => activeRegion.provinceNames.indexOf(o.name) > -1
          );
          this.provinceCity = undefined;
          this.ProvinceList = temp;
        } else {
          this.$message.warning("该大区尚未绑定省市！");
        }
      } else {
        this.ProvinceList = cloneDeep(this.tempProvinceCity);
      }
    }
  }
};
</script>
<template>
  <div class="StatisticsAgent">
    <div class="cardTitleText">区域统计图</div>
    <el-row :gutter="24" class="gameSearchForm">
      <el-col :span="24" class="colStyle">
        <span class="searchTitle">大区：</span>
        <span>
          <el-select
            v-model="regionId"
            placeholder="请选择"
            class="selectInputStyle"
            clearable
            filterable
            @change="onRangeSelect"
          >
            <el-option
              v-for="item in regionList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </span>
        <span class="searchTitle">省市：</span>
        <span>
          <el-cascader
            :options="ProvinceList"
            v-model="provinceCity"
            class="selectInputStyle"
            @change="onProvinceChange"
            clearable
            filterable
            :props="{ checkStrictly: true, expandTrigger: 'hover' }"
          ></el-cascader>
        </span>
        <span class="searchTitle">医疗机构：</span>
        <span>
          <el-select
            v-model="stationId"
            placeholder="请选择"
            @change="onStationSelect"
            class="selectInputStyle"
            clearable
            filterable
          >
            <el-option
              v-for="item in stationList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </span>
        <el-button class="searchButton" size="medium" @click="onSearch">搜索</el-button>
      </el-col>
      <!-- <el-col :span="12" class="colStyle targetView">
        <div class="searchLocation">
          <div>
            <div class="saleNumberTitle">业绩目标</div>
            <div
              class="saleNumber"
            >{{achievementData.sales || '--'}}/{{achievementData.targetCount || '--'}}疗程</div>
          </div>
          <div class="line"></div>
          <div>
            <div class="saleNumberTitle">剩余疗程</div>
            <div class="saleNumber">{{achievementData.remainingTreatmentCount || '--'}}疗程</div>
          </div>
          <div>
            <el-tag
              v-if="achievementData.remainingTreatmentCount && achievementData.remainingTreatmentCount < 100"
              size="mini"
              type="danger"
            >即将售罄</el-tag>
          </div>
        </div>
      </el-col>-->
    </el-row>
    <el-row :gutter="24" class="gameSearchForm">
      <el-col :span="20" class="colStyle">
        <span
          class="filterTab"
          :style="activeTab === 'sales' ? { color: '#ffffff', 'background-color': '#00c1de'} : ''"
          @click="onSwitchTab('sales')"
        >终端销量</span>
        <span
          class="filterTab"
          v-if="!stationId"
          :style="activeTab === 'agent' ? { color: '#ffffff', 'background-color': '#00c1de'} : ''"
          @click="onSwitchTab('agent')"
        >新增代理商</span>

        <!-- <span
          class="filterTab"
          :style="activeTab === 'stock' ? { color: '#ffffff', 'background-color': '#00c1de'} : ''"
          @click="onSwitchTab('stock')"
        >代理商存货</span>-->
        <!-- <span
          class="filterTab"
          :style="activeTab === 'courseBuy' ? { color: '#ffffff', 'background-color': '#00c1de'} : ''"
          @click="onSwitchTab('courseBuy')"
        >代理商进货</span>
        <span
          class="filterTab"
          :style="activeTab === 'courseRefund' ? { color: '#ffffff', 'background-color': '#00c1de'} : ''"
          @click="onSwitchTab('courseRefund')"
        >代理商退货</span>-->
        <span
          class="filterTab"
          v-if="!stationId"
          :style="activeTab === 'station' ? { color: '#ffffff', 'background-color': '#00c1de'} : ''"
          @click="onSwitchTab('station')"
        >新增医疗机构</span>
        <span
          class="filterTab"
          v-if="!stationId"
          :style="activeTab === 'lively' ? { color: '#ffffff', 'background-color': '#00c1de'} : ''"
          @click="onSwitchTab('lively')"
        >活跃医疗机构</span>
      </el-col>
      <el-col :span="4" class="colStyle targetView">
        <div class="selectDateView">
          <el-select
            v-model="dateRangeValue"
            @change="onDateTypeChange"
            class="timeFilterSelect"
            placeholder="请选择"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
      </el-col>
    </el-row>
    <div class="chartview" v-if="needRefresh1">
      <basicBarChart
        v-if="AgentSalesAndStation.StatisticsX"
        class="statisticsCharts"
        :StatisticsX="AgentSalesAndStation.StatisticsX"
        :StatisticsY="AgentSalesAndStation.StatisticsY"
        :legend="AgentSalesAndStation.legend"
        :chartTitle="AgentSalesAndStation.chartTitle"
        :chartYTitle="AgentSalesAndStation.chartYTitle"
        :yType="AgentSalesAndStation.yType"
        :seriesNameY="AgentSalesAndStation.seriesNameY"
        width="100%"
      />
    </div>
    <el-row :gutter="24" class="gameSearchForm">
      <el-col :span="12" class="colStyle">
        <div class="dateSelectTitle">累计销量</div>
        <div>
          <el-date-picker
            v-model="dateRange"
            size="medium"
            class="dateRange"
            type="daterange"
            range-separator="至"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="onDateChange"
          ></el-date-picker>
        </div>
      </el-col>
      <el-col :span="12" class="colStyle targetView">
        <div class="searchLocation" style="margin-top: 0px">
          <div>
            <div class="saleNumberTitle">本期销量</div>
            <div class="saleNumber">{{dateRangeTotalSales || '--'}}疗程</div>
          </div>
        </div>
      </el-col>
    </el-row>
    <div class="chartview" v-if="needRefresh2">
      <basicLineChart
        class="statisticsCharts"
        v-if="totalSales.StatisticsResult"
        :StatisticsResult="totalSales.StatisticsResult"
        :chartTitle="totalSales.chartTitle"
        :chartYTitle="totalSales.chartYTitle"
        :yType="totalSales.yType"
        :seriesNameY="totalSales.seriesNameY"
        width="100%"
      />
    </div>
  </div>
</template>

<style lang="scss">
@import "@/css/color.scss";

.StatisticsAgent {
  padding-left: 30px;
  padding-top: 15px;

  .cardTitleText {
    font-size: 20px;
    color: rgba(51, 51, 51, 1);
    line-height: 28px;
    margin: 15px 0;
  }

  .gameSearchForm {
    margin: 0px 0px 25px !important;
    color: rgba(89, 94, 122, 1);

    .colStyle {
      padding: 0 !important;
    }
    .targetView {
      float: right;
    }
    .selectInputStyle {
      width: 200px;
      margin-right: 10px;
    }

    .searchTitle {
      padding-right: 10px;
      display: inline-block;
    }
    .dateSelectTitle {
      padding-bottom: 10px;
      color: rgba(10, 10, 10, 1);
      line-height: 20px;
    }
    .dateRange {
      width: 250px;

      .el-range-editor--mini.el-input__inner {
        height: 32px;
      }

      .el-range-editor.is-active,
      .el-range-editor.is-active:hover {
        border-color: #00c1de;
      }

      .el-date-table td.today span {
        color: #00c1de;
      }
    }
    .filterTab {
      display: inline-block;
      margin-right: 20px;
      font-size: 14px;
      line-height: 20px;
      //   margin-left: -10px;
      padding: 5px 10px;
      border-radius: 4px;
      cursor: pointer;
    }
    .searchButton {
      background-color: #00c1de;
      border-color: #00c1de;
      color: #fff;
      height: 36px;
    }
    .searchLocation {
      float: right;
      display: flex;
      margin-right: 70px;
      margin-top: -20px;
      .line {
        width: 1px;
        height: 40px;
        background-color: #e4e8eb;
        margin-left: 25px;
        margin-right: 25px;
      }
      .saleNumberTitle {
        font-size: 14px;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.45);
        line-height: 22px;
      }
      .saleNumber {
        font-size: 20px;
        color: rgba(0, 0, 0, 0.85);
        line-height: 32px;
      }
    }
    .selectDateView {
      float: right;
      display: flex;
      margin-right: 30px;
      margin-top: -20px;

      .timeFilterSelect {
        width: 100px;
      }
    }
  }

  .chartview {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    min-height: 350px;
    .statisticsCharts {
      margin-bottom: 15px;
      margin-top: 15px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/visionStatistics/statisticManagerRange.vue